const decodedCookie = decodeURIComponent(document.cookie);
const arrayOfCookies = decodedCookie.split(";");
const hasSetDefaultLanguage =
  arrayOfCookies.includes("itlanguage=English") ||
  arrayOfCookies.includes("itlanguage=Srpski") ||
  arrayOfCookies.includes("itlanguage=Italian") ||
  arrayOfCookies.includes(" itlanguage=English") ||
  arrayOfCookies.includes(" itlanguage=Srpski") ||
  arrayOfCookies.includes(" itlanguage=Italian");

function setDefaultLanguage() {
  if (hasSetDefaultLanguage) {
    if (
      arrayOfCookies.includes("itlanguage=Srpski") ||
      arrayOfCookies.includes(" itlanguage=Srpski")
    ) {
      return "Srpski";
    } else if (
      arrayOfCookies.includes("itlanguage=Italian") ||
      arrayOfCookies.includes(" itlanguage=Italian")
    ) {
      return "Italian";
    } else {
      return "English";
    }
  } else {
    return "English";
  }
}

const initialState = {
  language: setDefaultLanguage(),
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "SETTING_LANGUAGE":
      document.cookie = `itlanguage=${action.data}; expires=Tue, 20 Aug 2021 12:00:00 UTC`;
      return {
        ...state,
        language: action.data,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/index.js